const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

const ago = (n: number, unit: string): string => `${n} ${unit}${n === 1 ? "" : "s"} ago`

/**
 * How long ago `date` was, in words: "just now", "5 minutes ago", "3 hours ago", "2 days ago",
 * then from a week back the date in the reader's locale (with the year when it isn't this year).
 * A time in the future (a clock ahead of this one) reads "just now".
 */
export const formatRelativeTime = (date: Date, now: Date = new Date()): string => {
  if (isNaN(date.getTime())) return ""
  const ms = now.getTime() - date.getTime()
  if (ms < MINUTE) return "just now"
  if (ms < HOUR) return ago(Math.floor(ms / MINUTE), "minute")
  if (ms < DAY) return ago(Math.floor(ms / HOUR), "hour")
  if (ms < 7 * DAY) return ago(Math.floor(ms / DAY), "day")
  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: date.getFullYear() === now.getFullYear() ? undefined : "numeric",
  })
}
